export const formatDateTimeStamp = (date) => {
    return new Date(date).toLocaleString("en-GB", {
        weekday: "long", // optional: to display weekday
        year: "numeric",
        month: "short", // short format for the month
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true, // optional: set true for 12-hour format (AM/PM)
    });
};


export const formatedDateIST = (date) => {
    return new Date(date).toLocaleDateString("en-GB");
};

export const calculateIncrementDate = (entryDate, incrementMonths) => {
  if (!entryDate || !incrementMonths) return "";

  const date = new Date(entryDate);
  date.setMonth(date.getMonth() + Number(incrementMonths));

  // format as yyyy-mm-dd (required for input[type="date"])
  return date.toISOString().split("T")[0];
};
